
import { Check, X, Save } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ImagePreviewProps {
  previewUrl: string;
  imageUrl: string;
  isUploading: boolean;
  onAccept: () => void;
  onReject: () => void;
  onSaveToGallery?: () => void;
}

const ImagePreview = ({ 
  previewUrl, 
  imageUrl, 
  isUploading, 
  onAccept, 
  onReject,
  onSaveToGallery
}: ImagePreviewProps) => {
  if (previewUrl) {
    return (
      <div className="mt-4 space-y-4">
        <p className="text-sm font-medium">Preview Generated Image:</p>
        <img
          src={previewUrl}
          alt="AI Generated Preview"
          className="w-64 h-64 object-cover rounded"
        />
        <div className="flex gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onAccept}
            disabled={isUploading}
            className="flex-1"
          >
            <Check className="mr-2 h-4 w-4" />
            Use This Image
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onSaveToGallery}
            disabled={isUploading || !onSaveToGallery}
            className="flex-1"
          >
            <Save className="mr-2 h-4 w-4" />
            Save to Gallery
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onReject}
            className="flex-1"
          >
            <X className="mr-2 h-4 w-4" />
            Discard
          </Button>
        </div>
      </div>
    );
  }

  if (imageUrl) {
    return (
      <div className="mt-2">
        <p className="text-sm font-medium mb-2">Selected Image:</p>
        <img
          src={imageUrl}
          alt="Preview"
          className="w-32 h-32 object-cover rounded"
        />
      </div>
    );
  }

  return null;
};

export default ImagePreview;
